import {NgModule} from '@angular/core';
import {NeqAccountPage} from './pages/account/account.page';
import {NeqFooterComponent} from './footer/footer.component';
import {NeqHeaderComponent} from './header/header.component';
import {NeqHomePage} from './pages/home/home.page';
import {NeqMenuComponent} from './menu/menu.component';
import {NeqPage} from './neq.page';
import {SharedCommonModule} from '@sharedcommon/shared-common.module';
import {NeqAdvancedRawmaterialsSearchPopinComponent} from '@usercommon/components/advanced-rawmaterials-search/advanced-rawmaterials-search-popin.component';
import {NeqAdvancedReferencesSearchPopinComponent} from '@usercommon/components/advanced-references-search/advanced-references-search-popin.component';
import {NeqRawmaterialsOrSamplesManagePage} from './pages/rawmaterials-or-samples/rawmaterials-or-samples-manage.page';
import {NeqRawmaterialsListPage} from './pages/rawmaterials/rawmaterials-list.page';
import {NeqRawmaterialsPropertiesPage} from './pages/rawmaterials/rawmaterials-properties.page';
import {NeqRawmaterialsOrSamplesComponent } from '@usercommon/components/rawmaterials-or-samples/rawmaterials-or-samples-values/rawmaterials-or-samples-values.component';
import {NeqRawmaterialsOrSamplesResultsComponent} from '@usercommon/components/rawmaterials-or-samples/rawmaterials-or-samples-results/rawmaterials-or-samples-results.component';
import {NeqResultsTableComponent} from '@usercommon/components/rawmaterials-or-samples/results-tables/results-tables.component';
import {RawmaterialOrSampleService} from '@usercommon/service/rawmaterial-or-sample.service';
import {NeqUserPropertiesComponent} from '@usercommon/components/user-properties/user-properties.component';
import {NeqUserPreferencesComponent} from '@usercommon/components/user-properties/user-preferences.component';
import {NeqRawmaterialOrSampleResultsSettingsPopin} from '../../common/components/rawmaterials-or-samples/rawmaterials-or-samples-results-settings-popin/rawmaterials-or-samples-results-settings-popin.component';
import {NeqLoginPage} from '../login/login.page';
import { NeqErrorPage } from '../error/error.page';
import {NeqReportDialogComponent} from '@usercommon/components/report/report.dialog';
import {NeqExportSettingsPage} from './pages/export/settings/export-settings.page';
import {
  NeqRawMaterialsConfirmationPopinComponent
} from '@usercommon/components/rawmaterials/confirmation-popin/rawmaterials-confirmation-popin.component';
import {RawMaterialMatricesResolver} from '@usercommon/resolvers/rawmaterial-matrices-resolver';
import {NeqCalculateBatchPopinComponent} from '@usercommon/components/rawmaterials/calculate-batch-popin/calculate-batch-popin.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PrimengTableService} from '@sharedcommon/components/primeng-table/primeng-table.service';
import {MatDialogModule} from '@angular/material/dialog';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {
  RawMaterialFacultativeErrorPopin
} from '@usercommon/components/rawmaterials/rawmaterial-facultative-error-popin/rawmaterial-facultative-error-popin.component';
import {
  NeqRawmaterialsAdditionalActionsComponent
} from '@usercommon/components/rawmaterials/rawmaterials-additional-actions/rawmaterials-additional-actions.component';
import {
  NeqRawMaterialBlockedResultsPopinComponent
} from '@usercommon/components/rawmaterials/rawmaterial-blocked-results-popin/rawmaterial-blocked-results-popin.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { ColorizeOptionPipe } from '@usercommon/components/header/import-semiauto/colorize-option.pipe';
import { ImportSemiautoComponent } from '@usercommon/components/header/import-semiauto/import-semiauto.component';
import { ImportSemiAutoStore } from '@usercommon/stores/import-semiauto.store';

import {SplitButtonModule} from 'primeng/splitbutton';
import { NeqSamplesListPage } from './pages/samples/samples-list/samples-list.page';
import { HomeRedirectionPage } from './pages/home-redirection/home-redirection.page';
import { RawmaterialsImportFullAutoPopin } from '@usercommon/components/rawmaterials/rawmaterials-import-full-auto-popin/rawmaterials-import-full-auto-popin.component';
import { RawmaterialsImportSemiAutoPopinComponent } from '@usercommon/components/rawmaterials/rawmaterials-import-semi-auto-popin/rawmaterials-import-semi-auto-popin.component';
import { NeqAdvancedSamplesSearchPopinComponent } from '@usercommon/components/advanced-samples-search/advanced-samples-search-popin.component';
import { SampleAdvancedSearchService } from '@usercommon/service/sample-advanced-search.service';
import { AdvancedSampleMultipleAutocompleteComponent } from '@usercommon/components/advanced-samples-search/advanced-sample-multiple-select/advanced-sample-multiple-select.component';
import { NeqRawmaterialsMultiEditPage } from './pages/rawmaterials/rawmaterials-multi-edit.page';
import { RawmaterialsMultiEditErrorPopinComponent } from '@usercommon/components/rawmaterials/rawmaterials-multi-edit-error-popin/rawmaterials-multi-edit-error-popin.component';
import { NeqSampleMandatoryProperties } from '../../common/components/samples/samples-mandatory-properties/samples-mandatory-properties.component';
import { NeqSamplesPropertiesPage } from './pages/samples/sample-properties/samples-properties.page';
import {RmOrSampleMultimodificationComponent} from "@usercommon/components/header/rm-or-sample-multi-modification/rm-or-sample-multimodification.component";
import {RmOrSampleMultiModificationStore} from "@usercommon/stores/rm-or-sample-multi-modification.store";
import { NeqSampleOptionalProperties } from '@usercommon/components/samples/samples-optional-properties/samples-optional-properties.component';
import { SimpleReferencesSearchPopinComponent } from '@usercommon/components/simple-references-search-popin/simple-references-search-popin.component';
import { NeqEntityChoicePage } from '@usercommon/components/entity-choice/entity-choice.page';

@NgModule({
  declarations: [
    NeqRawmaterialsOrSamplesManagePage, NeqRawmaterialsListPage, NeqRawmaterialsPropertiesPage, NeqRawmaterialOrSampleResultsSettingsPopin,
    NeqRawmaterialsOrSamplesResultsComponent, NeqRawmaterialsOrSamplesComponent, NeqRawmaterialsMultiEditPage,
    NeqSamplesListPage,
    NeqReportDialogComponent,
    NeqResultsTableComponent,
    NeqHeaderComponent, NeqFooterComponent,
    NeqHomePage,
    NeqMenuComponent,
    NeqPage,
    NeqAccountPage,
    NeqUserPropertiesComponent,
    NeqUserPreferencesComponent,
    NeqAdvancedRawmaterialsSearchPopinComponent, NeqAdvancedReferencesSearchPopinComponent, RawMaterialFacultativeErrorPopin,
    NeqLoginPage, NeqRawmaterialsAdditionalActionsComponent, NeqRawMaterialBlockedResultsPopinComponent,
    NeqExportSettingsPage, NeqRawMaterialsConfirmationPopinComponent, NeqCalculateBatchPopinComponent,
    RawmaterialsImportFullAutoPopin, ImportSemiautoComponent, ColorizeOptionPipe, RawmaterialsMultiEditErrorPopinComponent,
    HomeRedirectionPage, RawmaterialsImportSemiAutoPopinComponent, NeqAdvancedSamplesSearchPopinComponent, AdvancedSampleMultipleAutocompleteComponent,
    RmOrSampleMultimodificationComponent,
    NeqSampleMandatoryProperties, NeqSamplesPropertiesPage, NeqSampleOptionalProperties,
    SimpleReferencesSearchPopinComponent, NeqEntityChoicePage,
    NeqErrorPage
  ],
  imports: [
    SharedCommonModule,
    MatProgressBarModule,
    MatDialogModule,
    MatSlideToggleModule, MatButtonToggleModule,
    SplitButtonModule
  ],
  exports: [
  ],
  providers: [
    RawmaterialOrSampleService, RawMaterialMatricesResolver, PrimengTableService, ValidationService, ImportSemiAutoStore, SampleAdvancedSearchService, RmOrSampleMultiModificationStore
  ],
  entryComponents: [
    NeqReportDialogComponent,
    NeqAdvancedRawmaterialsSearchPopinComponent,
    NeqAdvancedReferencesSearchPopinComponent,
    NeqRawmaterialOrSampleResultsSettingsPopin,
    NeqRawMaterialsConfirmationPopinComponent,
    NeqCalculateBatchPopinComponent, RawmaterialsImportFullAutoPopin,
    RawmaterialsImportSemiAutoPopinComponent, NeqAdvancedSamplesSearchPopinComponent
  ]
})
export class NeqModule {
}
